import { renderToStaticMarkup } from "react-dom/server";

export const svgComponentToCSS = (Component: JSX.Element): string =>
	`url("data:image/svg+xml,${encodeURIComponent(renderToStaticMarkup(Component))}")`;
